import { ValuationsApproach } from 'common/types/valuation';
import { getApproachTableName } from 'pages/ValuationsAllocation/util';
import createExchangeRateReferenceConfig
  from './ExchangeRatesReferenceTable/createExchangeRateReferenceConfig/createExchangeRateReferenceConfig';
import {
  ExchangeRateRowInput
} from './ExchangeRatesReferenceTable/createExchangeRateReferenceConfig/createExchangeRateReferenceConfigProps';
import createGpcData from './gpc/createGpcData';
import GPC from './GuidelinePublicCompanies';
import { createPerformanceMetrics } from './PerformanceMetrics';
import { CreateGpcConfigParams } from './types';
import {FINANCIALS_CURRENCY, MARKET_CURRENCY} from '../../util/constants';

const createGpcConfig = (params: CreateGpcConfigParams) => {
  const {
    approach,
    companyName,
    compGroups,
    customClasses,
    financials,
    financialsPeriods,
    gpcAttributes,
    isDisabled,
    measurementDate,
    marketDate,
    financialsCurrency,
    marketCurrency,
  } = params;
  const name = getApproachTableName({ approach: approach as ValuationsApproach });

  const gpcSheet = createGpcData({
    approach,
    companyName,
    compGroups,
    financials,
    financialsPeriods,
    gpcAttributes,
    name,
    isDisabled,
    measurementDate,
    marketDate,
  });

  const marketMatchesFinancialsCurrency = marketCurrency === financialsCurrency;

  const { spreadsheet: performanceMetricsSheet } = createPerformanceMetrics({
    approach,
    companyName,
    customClasses,
    financials,
    isDisabled,
    marketMatchesFinancialsCurrency,
  });
  const exchangeRateRowInput: ExchangeRateRowInput[] = [{
    alias: FINANCIALS_CURRENCY,
    value: `Financials Currency (${financialsCurrency})`,
    customKey: FINANCIALS_CURRENCY,
  }, {
    alias: MARKET_CURRENCY,
    value:  `Market Currency (${marketCurrency})`,
    customKey: MARKET_CURRENCY,
  }]
  const exchangeRateSheet = createExchangeRateReferenceConfig({
    approach, exchangeRateRowInput
  })

  return {
    approach,
    name,
    component: GPC,
    enterpriseValueReference: name,
    spreadsheets: {
      gpc: gpcSheet,
      performanceMetrics: performanceMetricsSheet,
      exchangeRates: exchangeRateSheet,
    },
    value: approach?.enterprise_value,
  };
};

export default createGpcConfig;
